import { get, genericRequestNoResponse } from './fetch';

export const getBlockableTypes = (customerId) => {
  return get({ endpoint: `api/communication-preferences/blockable-types?customerId=${customerId}` });
};

export const blockType = (customerId, notificationTypeId) => {
  return genericRequestNoResponse({ endpoint: `api/communication-preferences/blockable-types/${notificationTypeId}?customerId=${customerId}` }, 'POST');
};
